/**
 * Fixed-height list virtualization for the Console: the log keeps up to
 * 2000 entries, and only the rows in view (plus a margin) are rendered.
 */

export interface WindowInput {
  readonly scrollTop: number;
  /** 0 before the list is laid out: then every row renders. */
  readonly viewportHeight: number;
  readonly rowHeight: number;
  readonly count: number;
  /** Extra rows above and below the view, so fast scrolling never shows gaps. */
  readonly overscan?: number;
}

export function visibleWindow({
  scrollTop,
  viewportHeight,
  rowHeight,
  count,
  overscan = 10,
}: WindowInput): { start: number; end: number } {
  if (viewportHeight <= 0) return { start: 0, end: count };

  const first = Math.floor(scrollTop / rowHeight);
  const last = Math.ceil((scrollTop + viewportHeight) / rowHeight);
  return { start: Math.max(0, first - overscan), end: Math.min(count, last + overscan) };
}
